import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'src/i18n';

// Tri-state answer bound to an extras path. Values match the check sheet task vocabulary
// (pass/fail/na) so stored data is consistent whether an answer comes from a task row or here;
// only the labels read Yes/No/N-A.
export default function YesNoNaField (props) {
  const { label, value, onChange, readOnly, size, showNa } = props;
  const { t } = useTranslation();

  const options = [
    { value: 'pass', label: t('common.yes') },
    { value: 'fail', label: t('common.no') },
    ...(showNa ? [{ value: 'na', label: t('common.na') }] : []),
  ];

  // FormControl/InputLabel rather than a plain span: the label then inherits the app's
  // MuiInputLabel theme styling, so it matches the TextField labels these sit beside.
  return (
    <FormControl variant='outlined' className='yes-no-na-field' fullWidth>
      {label && <InputLabel shrink={false}>{label}</InputLabel>}
      <ToggleButtonGroup
        value={value || ''}
        exclusive
        size={size}
        disabled={readOnly}
        onChange={(_e, val) => onChange(val)}
      >
        {options.map(opt => (
          <ToggleButton key={opt.value} value={opt.value} className={`commissioning-status-${opt.value}`}>
            {opt.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FormControl>
  );
}

YesNoNaField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  // False for questions with no meaningful N/A answer, e.g. whether it rained.
  showNa: PropTypes.bool,
};

YesNoNaField.defaultProps = {
  value: '',
  readOnly: false,
  size: 'small',
  showNa: true,
};
